var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.598,
    height: 17.42,
    viewBox: "0 0 19.598 17.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-current",
    d: "M15.636,18.252v-.9a4.863,4.863,0,0,0,2.177-4.046c0-2.706,0-4.9-3.266-4.9s-3.266,2.194-3.266,4.9a4.863,4.863,0,0,0,2.178,4.046v.9c-3.693.3-6.533,2.117-6.533,4.311H22.169c0-2.194-2.839-4.009-6.533-4.311Zm-7.5.42a10.344,10.344,0,0,1,3.4-1.368,6.142,6.142,0,0,1-.689-1,6.234,6.234,0,0,1-.791-2.992,9.667,9.667,0,0,1,.521-3.977A3.545,3.545,0,0,1,13.286,7.3C13,6,12.232,5.143,10.193,5.143c-3.266,0-3.266,2.194-3.266,4.9A4.863,4.863,0,0,0,9.1,14.088v.9c-3.693.3-6.532,2.117-6.532,4.311H7.318a6.974,6.974,0,0,1,.82-.624Z",
    "data-name": "Icon metro-users",
    transform: "translate(-2.571 -5.143)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.08b0f2fb75850f9cbb8e4a29757b1227.svg";
export { ForwardRef as ReactComponent };